import * as angular from 'angular';


export class AncillariesSeatTransformer {
    constructor (
        private AncillariesConstants: AncillariesConstant,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private CurrencyService: CurrencyService
    ) {}

    generateSlicesSeatInfo = (ancillariesSeatInfo: any, cachedData: any) => {
        const segmentList = [], passengerList = [], orderSegmentList = [], segmentsOrderedAvailable = [], segmentsSeatAvailable = [];
        angular.forEach(cachedData.order.slices, (slice) => {
            angular.forEach(slice.segments, (segment) => {
                orderSegmentList.push(segment.id);
            });
        });
        angular.forEach(ancillariesSeatInfo.segments, (segment) => {
            angular.forEach(segment.passengers, (pas) => {
                if (passengerList.indexOf(pas) === -1) {
                    passengerList.push(pas);
                }
            });
            if (segment.status.code === this.AncillariesConstants.STATUS.AVAILABLE) {
                segmentsSeatAvailable.push(segment.id);
            }
            segmentList.push(segment.id);
        });
        for (let i = 0; i < orderSegmentList.length; i++) {
            if (segmentList.indexOf(orderSegmentList[i]) !== -1) {
                segmentsOrderedAvailable.push(orderSegmentList[i]);
            }
        }
        this.localStorageService.set('seatsAvailableSegments', segmentsSeatAvailable);
        this.localStorageService.set('ancillariesAvailableSegments', segmentsOrderedAvailable);
        this.localStorageService.set('ancillariesAvailablePassengers', passengerList);

        return segmentsOrderedAvailable;
    };

    getMinPriceSeat = (segments:  any, currency: any) => {
        const listPrice = [];
        let price = null;
        angular.forEach(segments, (segment) => {
            angular.forEach(segment.passengers, (pas) => {
                if (pas.priceFrom !== null && pas.priceFrom >= 0) {
                    listPrice.push(pas.priceFrom);
                }
            });
        });

        if (listPrice.length > 0) {
            price = listPrice.sort((a, b) => {
                return a - b;
            });
            price = this.CurrencyService.formatPrice(currency, price[0], true, false);
        }
        return price;
    };

    availableSegmentSeats = (ancillariesInfo: any, cachedData: any) => {
        let seatsQuanty = 0;
        const segmentsWithAvailableSeats = [];
        for(let j = 0; j < ancillariesInfo.ancillaries.length; j++) {
            if(ancillariesInfo.ancillaries[j].type.toLowerCase() === 'seat') {
                for(let k = 0; k < ancillariesInfo.ancillaries[j].segments.length; k++) {
                    if(ancillariesInfo.ancillaries[j].segments[k].status.code.toLowerCase() === 'available') {
                        segmentsWithAvailableSeats.push(ancillariesInfo.ancillaries[j].segments[k].id);
                    }
                }
            }
        }
        for(let j = 0; j < cachedData.order.orderItems.length; j++) {
            if(cachedData.order.orderItems[j].type.toLowerCase() === 'seat') {
                for(let k = 0; k < segmentsWithAvailableSeats.length; k++) {
                    if(cachedData.order.orderItems[j].segmentId === segmentsWithAvailableSeats[k]) {
                        seatsQuanty++;
                    }
                }
            }
        }
        this.localStorageService.set('seatsQuanty', seatsQuanty);
        return seatsQuanty;
    };
}

AncillariesSeatTransformer.$inject = ['AncillariesConstants', 'localStorageService', 'CurrencyService'];
try {
    const mod = angular.module('ib-web-ancillaries-module');
    mod.service('AncillariesSeatTransformer', AncillariesSeatTransformer);
} catch (error) {
    const mod = angular.module('ib-web-ancillaries-module', []);
    mod.service('AncillariesSeatTransformer', AncillariesSeatTransformer);
}
